// @flow

import type {
  Pathname,
  State,
  Location,
} from './types';

// this extends the connected-router-redux reducer

type GlobalState = {
  router: State,
};

// We assume this reducer is included as 'router' in state
export const getReducer = (state: GlobalState): State => state.router;

export const getLocation = (state: GlobalState): Location => getReducer(state).location;

export const getPathname = (state: GlobalState): Pathname => {
  const location = getLocation(state);
  if (!location) {
    return '';
  }

  return location.pathname;
};

export const getSearch = (state: GlobalState): string => {
  const location = getLocation(state);
  if (!location) {
    return '';
  }

  return location.search;
};

export const getSlug = (state: GlobalState): string => getPathname(state);

export const getLocationState = (state: GlobalState) => {
  const location = getLocation(state);
  if (!location) {
    return null;
  }
  return location.state;
};

export const getPreventScrollTop = (state: GlobalState) => {
  const locationState = getLocationState(state);
  if (!locationState) {
    return null;
  }
  return locationState.preventScrollTop;
};
